import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Document, Page, pdfjs } from 'react-pdf'
import 'react-pdf/dist/Page/AnnotationLayer.css'
import 'react-pdf/dist/Page/TextLayer.css'

// Configure PDF.js worker (must be in same module as Document/Page usage)
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`

const ConsentPdfViewer = ({ url, title }) => {
  const [numPages, setNumPages] = useState(null)
  const [error, setError] = useState(null)

  const onDocumentLoadSuccess = ({ numPages: total }) => {
    setNumPages(total)
    setError(null)
  }

  const onDocumentLoadError = (err) => {
    setError(err?.message || 'Failed to load PDF')
    setNumPages(null)
  }

  useEffect(() => {
    setNumPages(null)
    setError(null)
  }, [url])

  if (!url) return null

  if (error) {
    return (
      <div className='consent-pdf-error'>
        <p>{error}</p>
      </div>
    )
  }

  return (
    <div className='consent-pdf-viewer'>
      <Document
        file={{ url }}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={onDocumentLoadError}
        loading={
          <div className='consent-pdf-loading'>Loading PDF…</div>
        }
      >
        {numPages != null &&
          Array.from({ length: numPages }, (_, i) => (
            <Page
              key={`page-${i + 1}`}
              pageNumber={i + 1}
              width={typeof window !== 'undefined' ? Math.min(window.innerWidth - 64, 800) : 800}
              renderTextLayer
              renderAnnotationLayer
            />
          ))}
      </Document>
    </div>
  )
}

ConsentPdfViewer.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string
}

export default ConsentPdfViewer
